/*website*/
import request from "@/utils/request";

import { getItemSiteLang } from "@/utils/common.js";
// import { WEBSITE_LANG_DEFAULT } from "@/utils/config.ts";

/**
 * @param params
 */
export function siteList(params) {
    return request.get(`/cms/site`, params);
}

/*获取  site_lang 参数*/
export function getSiteLang(params = {}) {
    if (params && (params.lang == "cn" || params.lang == "en")) {
        return params.lang;
    } else {
        // return getItemSiteLang() || WEBSITE_LANG_DEFAULT;
        return getItemSiteLang();
    }
}

/*站点 编辑页*/
export function siteGet(params) {
    return request.get(`/cms/site/` + params.lang);
}
export function siteEdit(params) {
    return request.post(`/cms/site/` + getSiteLang(params), params);
}

/*栏目列表*/
export function catalogList(params = {}) {
    params.lang = getSiteLang(params);
    return request.get(`/cms/catalog`, params);
}

/*栏目列表*/
export function catalogIndexList(params = {}) {
    params.lang = getSiteLang(params);

    return request.get(`/cms/catalog/list`, params);
}

export function paramsList(params) {
    return request.get(`/cms/params/catalog`, params);
}
export function paramsData(params) {
    return request.get(`/cms/params-read/` + params.id);
}
export function paramsDataPost(params) {
    return request.post(`/cms/params-read`, params);
}
export function articleManageList(params) {
    return request.get(`/cms/params/article`, params);
}


/**
 * @param params
 *      id
 */
export function catalogDel(params) {
    return request.delete(`/cms/catalog/` + params.id);
}

/**
 * @param params
 *      id
 */
export function catalogGet(params) {
    return request.get(`/cms/catalog/` + params.id);
}

export function catalogEdit(params) {
    if (params.id) {
        return request.post(`/cms/catalog/` + params.id, params);
    } else {
        params.lang = getSiteLang(params);

        return request.post(`/cms/catalog`, params);
    }
}

/*内容页*/
/*文章*/
export function articleList(params) {
    params.lang = getSiteLang(params);

    return request.get(`/cms/article`, params);
}

/*文章*/
export function articleGet(params) {
    return request.get(`/cms/article/` + params.id);
}

export function articleEdit(params) {
    if (params.id) {
        return request.post(`/cms/article/` + params.id, params);
    } else {
        params.lang = getSiteLang(params);

        return request.post(`/cms/article`, params);
    }
}


export function articleDel(params) {
    return request.delete(`/cms/article`, params);
}

/**
 * @param params
 */
export function edit(params) {
    if (params.id) {
        return request.post(`/cms/orders/` + params.id, params);
    } else {
        return request.post(`/cms/orders`, params);
    }
}

/**
 * @param params
 */
export function getEdit(params) {
    return request.get(`/cms/orders/` + params.id);
}

/**
 * @param params
 */
export function del(params) {
    return request.delete(`/cms/orders/` + params.id);
    // return request.get(`cms/company`, params)
}

export function orderEdit() {
    return request.get(`/cms/orders-config`);
}

/*菜单管理*/
export function columnList(params = {}) {
    params.lang = getSiteLang(params);

    return request.get(`/cms/column`, params);
}

/**
 * @param params
 *      id
 */
export function columnDel(params) {
    return request.delete(`/cms/column/` + params.id);
}

/**
 * @param params
 *      id
 */
export function columnGet(params) {
    return request.get(`/cms/column/` + params.id);
}

export function columnEdit(params) {
    if (params.id) {
        return request.post(`/cms/column/` + params.id, params);
    } else {
        // params.lang = getSiteLang(params);

        return request.post(`/cms/column`, params);
    }
}

export function savaOrder(params) {
    return request.post(`/cms/column/save-order`, params);
}

// 内容回收站
export function articleRecycle(params = {}) {
    params.lang = getSiteLang(params);
    return request.get(`/cms/article-recycle`, params);
}

//   内容恢复
export function recoverPost(params) {
    return request.post(`/cms/article-recover`, params);
}
// 内容彻底删除
export function removeDel(params) {
    return request.delete(`/cms/article-delete`, params);
}

// 资源回收站
export function resourceRecycle(params) {
    return request.get(`/cms/resource-recycle`, params);
}

// 资源恢复
export function resourcePost(params) {
    return request.post(`/cms/resource-recover`, params);
}
//  资源彻底删除
export function resourceDel(params) {
    return request.delete(`/cms/resource-delete`, params);
}

//自定义字段
export function paramsPost(params) {
    return request.post(`/cms/params`, params);
}

export function paramsDel(params) {
    return request.delete(`/cms/params`, params);
}


export function paramsEdit(params) {
    if (params.id) {
        return request.post(`/cms/params/` + params.id, params);
    } else {
        return request.post(`/cms/params`, params);
    }
}


export function getParams(params) {
    return request.get(`/cms/getParams`, params);
}


//   根据分类选文章

export function articleCatalog(params) {
    return request.get(`/cms/article-catalog`, params);
}



export function editSimple(params) {
    if (params.id) {
        return request.post(`/cms/article-editSimple/` + params.id, params);
    } else {
        return request.post(`/article-editSimple`, params);
    }
}

export function articleCopy(params) {
    return request.post(`/cms/article-copy`, params);
}


export function tagsGet(params) {
    return request.get(`/cms/tags`, params);
}

export function tagsPost(params) {
    return request.post(`/cms/tags`, params);
}


export function tagsIdGet(params) {
    return request.get(`/cms/tags/` + params.id);
}

export function tagsIdPost(params) {
    return request.post(`/cms/tags/` + params.id, params);
}

export function tagsDel(params) {
    return request.delete(`/cms/tags`, params);
}
